import { Tabs } from '@ui/lib/park/ui/tabs';
import { useTranslation } from 'next-i18next';

export enum MarginTab {
  Add = 'add',
  Remove = 'remove',
}

export const AddRemoveButtonGroup = ({
  tab,
  setTab,
  ...p
}: Omit<Tabs.RootProps, 'value' | 'onValueChange'> & {
  tab: MarginTab;
  setTab: (tab: MarginTab) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Tabs.Root
      variant="longShort"
      size="md"
      value={tab}
      onValueChange={(v) => {
        setTab(v.value as MarginTab);
      }}
      {...p}
    >
      {/* V2: active segments are SOLID accent fills — never translucent accent-on-dark */}
      <Tabs.List boxShadow="none" p="2px" gap="2px">
        <Tabs.Trigger
          flex={1}
          value={MarginTab.Add}
          textStyle="headings.small"
          h="32px"
          color="v2.text.muted"
          _selected={{
            color: 'v2.text.onAccent !important',
            backgroundColor: 'v2.long.default',
          }}
          _hover={{ color: 'greyWhite.lightGrey2' }}
          data-cy="MarginAddTab"
        >
          {t('common.Add')}
        </Tabs.Trigger>
        <Tabs.Trigger
          flex={1}
          value={MarginTab.Remove}
          textStyle="headings.small"
          h="32px"
          color="v2.text.muted"
          _selected={{
            color: 'white !important',
            backgroundColor: 'v2.short.default',
          }}
          _hover={{ color: 'greyWhite.lightGrey2' }}
          data-cy="MarginRemoveTab"
        >
          {t('common.Remove')}
        </Tabs.Trigger>
      </Tabs.List>
    </Tabs.Root>
  );
};
